var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.messageCount > 0),expression:"messageCount > 0"}],staticClass:"btn-tiny-circle btn-orange"},[_vm._v(" "+_vm._s(_vm.messageCount)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }